import { Fragment, useEffect, useRef, useState } from "react";
import { useHistory } from "react-router";
import { getSession, processInt, processNum, processStr, processStrWithSpace, valdiatePage } from "../../global";
import { getLocations } from "../../services/userservice";
import { getDarazCNs, getRiders, generateDarazLoadsheet, checkExistingCNs } from "../../services/loadsheetservice";
import Loader from '../../images/whiteloader.svg';
import { useDispatch, useSelector } from "react-redux";
import { setLoading } from "../../redux/appSlice";
import { setData, resetData, setGrid, setRiders, setLocations, updateGrid as updateG } from "../../redux/darazLoadsheetSlice";
import './darazLoadsheet.css';

const DarazLoadsheet = () => {
    const cnRef = useRef(null);
    const cnsRef = useRef(null);
    const dispatch = useDispatch();
    const { appData, darazLoadSheetData } = useSelector(state => {
        return {
            appData: state.appData,
            darazLoadSheetData: state.darazLoadSheetData,
        }
    });

    const { loading, userInfo, subaccounts, services } = appData;
    const { data, grid, riders, locations } = darazLoadSheetData;

    const history = useHistory();

    const [nfcns, setnfcns] = useState([]);

    useEffect(() => {
        if (valdiatePage('/darazLoadsheet')) {

        } else {
            history.push('/login');
        }
        return () => {
            dispatch(setGrid({ data: [] }));
            dispatch(resetData({}));
        }
    }, []);

    const updateData = (key, val) => dispatch(setData({ data: { ...data, [key]: val } }));

    const updateGrid = (index, key, val) => {
        dispatch(updateG({ index, key, val }));
    }

    const onSearch = async () => {
        if (data.locationIds.length == 0) {
            alert('Select Location');
            return;
        }
        if (Date.parse(data.from) > Date.parse(data.to)) {
            alert('Invalid Date');
            return;
        }

        dispatch(setLoading({ data: true }));
        const rs = await getDarazCNs({ from: data.from, to: data.to, accountNo: data.accountNo, LocationId: +data.locationIds[0] });
        dispatch(setLoading({ data: false }));


        if (rs.sts == 0) {
            if (rs.data && rs.data.length > 0) {
                dispatch(setGrid({ data: rs.data }));
            } else {
                alert('No data found');
            }
        } else {
            alert(rs.msg);
        }
    }

    useEffect(() => {
        if (data.locationIds.length > 0) {
            getRiders(data.locationIds).then(rs => {
                if (rs.sts == 0)
                    dispatch(setRiders({ data: rs.data }))
            });
        } else {
            dispatch(setRiders({ data: [] }));
        }
    }, [data.locationIds])

    const onGenerateLoadsheet = async (d) => {

        if (!data.riderCode) {
            alert('Select Rider');
            return;
        }

        if (data.weightRequired) {
            if (d.some(x => (!x.cnWeight || +x.cnWeight <= 0 || +x.cnWeight > 99))) {
                alert("Invalid Weight found in Grid");
                return;
            }
        }

        if (d.some(x => !x.extra && (!x.pcs || +x.pcs <= 0))) {
            alert("Invalid Pieces found in Grid");
            return;
        }


        if (d.some(x => !x.extra && (+x.weight <= 0 || +x.weight > 99))) {
            alert("Invalid Weight found in Grid");
            return;
        }


        const z = {
            locationId: +data.locationIds[0],
            riderCode: data.riderCode,
            userId: userInfo.id,
            consignmentsData: d.map(c => {
                return {
                    cn: c.cn,
                    pcs: c.pcs,
                    weight: c.weight,
                    consignee: c.consignee,
                    refNo: c.refNo,
                    serviceType: c.serviceType,
                    productDetails: c.productDetails,
                    remarks: c.remarks,
                    locationId: c.locationId,
                    cnWeight: c.cnWeight,
                    editMode: c.editMode
                }
            })
        }

        const rs = await generateDarazLoadsheet(z);

        alert(rs.msg);

        if (rs.sts == 0) {
            const cns = d.map(c => c.cn);
            dispatch(setGrid({ data: grid.filter(c => !cns.includes(c.cn)) }));

            const printData = {
                customerName: userInfo.name,
                accountNo: data.accountNo,
                data: d
            }
            sessionStorage.setItem('loadsheetdata', JSON.stringify(printData));
            window.open('/cplight/loadsheet.html', '_blank');
        }
    }

    const onConsignmentBlur = async (e) => {
        const val = e.target.value;
        if (val && grid.length > 0) {
            const g = [...grid];
            if (g.some(y => y.cn == val)) {
                const rs = g.find(y => y.cn == val);
                if (!rs.selected) {
                    const index = g.indexOf(rs);
                    let obj = { ...rs };
                    obj.selected = true;
                    g.splice(index, 1);
                    g.unshift(obj);
                    dispatch(setGrid({ data: g }));
                } else {
                    alert('Already Scanned');
                }
            } else {
                const sequnce = getSession('sequences').filter(x => x.locationId == data.locationIds[0])[0];
                const start = Number(sequnce.sequenceStart);
                const end = Number(sequnce.sequenceEnd);
                let num = +val;
                if ((num >= start && num <= end)) {
                    const rs = await checkExistingCNs([val]);
                    if (rs && rs.ok) {
                        if (rs.data.length > 0) {
                            alert(`Consignment# ${num} already exists in Loadsheet`);
                        } else {
                            const z = {
                                extra: 'extra',
                                cn: val,
                                selected: true,
                                consignee: '',
                                pcs: 0,
                                weight: 0,
                                codAmount: 0,
                                bookingDate: '',
                                refNo: '',
                                destination: '',
                                serviceType: '',
                                productDetails: '',
                                remarks: '',
                                cnWeight: 0,
                            }
                            g.unshift(z);
                            dispatch(setGrid({ data: g }));
                        }
                    }
                } else {
                    alert(`Invalid Consignment# ${num}`);
                }
            }

            cnRef.current.value = '';
            cnRef.current.focus();
        }
    }

    const keypressHandler = e => {
        if (e.key === "Enter") {
            cnRef.current.blur();
        }
    }

    const multipleCNBlur = async (e) => {
        const val = e.target.value;
        if (val) {
            const cns = e.target.value.split('\n').filter(x => x != '');
            const g = [...grid];
            const z = [];

            const foundcns = g.filter(x => cns.includes(x.cn));

            for (const rs of foundcns) {
                const index = g.indexOf(rs);
                let obj = { ...rs };
                obj.selected = true;
                g.splice(index, 1);
                g.unshift(obj);
            }

            const notingridcns = cns.filter(x => !foundcns.map(y => y.cn).includes(x));

            if (notingridcns && notingridcns.length > 0) {
                const sequnce = getSession('sequences').filter(x => x.locationId == data.locationIds[0])[0];
                const start = +sequnce.sequenceStart;
                const end = +sequnce.sequenceEnd;

                const cnstocheck = notingridcns.filter(x => +x >= start && +x <= end).map(x => x);

                const b = notingridcns.filter(x => !cnstocheck.includes(x));

                for (let v of b) {
                    z.unshift({ cn: v, msg: 'Invalid Consignment#' });
                }

                const rs = await checkExistingCNs(cnstocheck);

                if (rs && rs.ok) {
                    const dt = rs.data;
                    if (dt.length > 0) {
                        for (let v of dt) {
                            z.unshift({ cn: v, msg: 'Already exists in Loadsheet' });
                        }
                    }
                    const x = cnstocheck.filter(c => !dt.includes(c)).map(c => ({
                        extra: 'extra',
                        cn: c,
                        selected: true,
                        consignee: '',
                        pcs: 0,
                        weight: 0,
                        codAmount: 0,
                        bookingDate: '',
                        refNo: '',
                        destination: '',
                        serviceType: '',
                        productDetails: '',
                        remarks: '',
                        cnWeight: 0,
                    }))
                    for (let v of x) {
                        g.unshift(v);
                    }
                }
            }
            dispatch(setGrid({ data: g }));
            setnfcns(z);
            cnsRef.current.value = '';
        }
    }

    return userInfo && <section className="section">
        <div className="section-header">
            <h1>Daraz Loadsheets</h1>
        </div>
        <div className="card" style={{ padding: 10 }}>
            <div className="row">
                <div className="col-lg-2">
                    <label>Sub Account</label>
                    <select className="form-select" value={data.subAccountId} onChange={async (e) => {
                        const val = e.target.value;
                        const accno = e.target[e.target.selectedIndex].getAttribute('data-accno');
                        const d = { ...data, subAccountId: val, accountNo: accno };
                        if (val) {
                            const locs = await getLocations(userInfo.id, accno)
                            if (locs) {
                                d.locationIds = [locs[0].value.toString()];
                                dispatch(setLocations({ data: locs }));
                            }
                        } else {
                            d.locationIds = [];
                            dispatch(setLocations({ data: [] }));
                        }
                        dispatch(setData({ data: d }));
                    }}>
                        <option value="" data-accno="">Select Sub Account</option>
                        {
                            subaccounts.map((x, index) => <option key={index} value={x.id} data-accno={x.accountNo}>{x.name}</option>)
                        }
                    </select>
                </div>
                <div className="col-lg-2">
                    <label>Locations</label>
                    <select className="form-select" disabled={true} value={data.locationIds} onChange={(e) => {
                        const values = Array.from(e.target.selectedOptions, option => option.value.toString());
                        dispatch(setData({ data: { ...data, locationIds: values } }));
                    }} multiple>
                        {
                            locations.map((x, index) => <option key={index} value={x.value}>{x.text}</option>)
                        }
                    </select>
                </div>
                <div className="col-lg-2">
                    <label>Order From</label>
                    <input type="date" className="form-control" value={data.from} onChange={(e) => updateData('from', e.target.value)} />
                </div>
                <div className="col-lg-2">
                    <label>Order To</label>
                    <input type="date" className="form-control" value={data.to} onChange={(e) => updateData('to', e.target.value)} />
                </div>
                <div className="col-lg-2">
                    <label>Riders</label>
                    <select className="form-select" value={data.riderCode} onChange={(e) => updateData('riderCode', e.target.value)}>
                        <option value="">Select Rider</option>
                        {
                            riders.map((x, index) => <option key={index} value={x.value}>{x.text}</option>)
                        }
                    </select>
                </div>

                <div className="col-lg-2">
                    <button type="button" className="btn btn-primary" onClick={onSearch} disabled={loading} style={{ marginTop: 20 }}>
                        {loading ? <img src={Loader} height="30" /> : 'Search'}
                    </button>
                </div>
            </div>
            <div className="row mt-2">
                <div className="col-lg-2 col-sm-12">
                    <input type="text" className="form-control" onKeyPress={keypressHandler} onBlur={onConsignmentBlur} onInput={processInt} placeholder="Scan Consignment" ref={cnRef} />
                </div>
                <div className="col-lg-2 col-sm-12">
                    <textarea className="form-control" ref={cnsRef} onBlur={multipleCNBlur}></textarea>
                </div>
                <div className="col-lg-2 col-sm-12">
                    <p style={{ color: '#f46711', marginTop: 10, marginBottom: 0 }}>{grid.filter(y => y.selected).length} out of {grid.length} scanned</p>
                </div>
            </div>
            {
                nfcns.length > 0 &&
                <div className="row mt-3">
                    <div className="col-12">
                        <div className="table-responsive">
                            <table className="table table bordered">
                                <thead>
                                    <tr>
                                        <th>Consignment#</th>
                                        <th>Message</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        nfcns.map((x, index) =>
                                            <tr key={index}>
                                                <td>{x.cn}</td>
                                                <td>{x.msg}</td>
                                            </tr>)
                                    }
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            }
            {
                grid.length > 0 && <div className="row mt-3">
                    <div className="col-12">
                        <div className="table-responsive">
                            <table className="table table bordered">
                                <thead>
                                    <tr>
                                        <th>S.No</th>
                                        <th style={{ position: 'relative' }}><input className="form-check-input" type="checkbox" checked={grid.length === grid.filter(y => y.selected).length} onChange={(e) => {
                                            const g = grid.map(y => {
                                                return { ...y, selected: e.target.checked }
                                            });
                                            dispatch(setGrid({ data: g }));
                                        }} /></th>
                                        <th>
                                            <button type="button" className="btn btn-sm btn-primary" onClick={async () => {
                                                if (window.confirm('Are you sure?')) {
                                                    const d = grid.filter(c => c.selected);
                                                    if (d.length > 0) {
                                                        await onGenerateLoadsheet(d);
                                                    } else {
                                                        alert('Select Consignments');
                                                    }
                                                }
                                            }}>Combined Loadsheet</button>
                                        </th>
                                        <th>Edit</th>
                                        <th>Consignment No</th>
                                        <th>Consignee</th>
                                        <th>Pieces</th>
                                        <th>Weight</th>
                                        <th>Cod Amount</th>
                                        <th>Reference No</th>
                                        <th>Booking Date</th>
                                        <th>Service Type</th>
                                        <th>Product Details</th>
                                        <th>Remarks</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        grid.map((x, index) =>
                                            <Fragment key={index}>
                                                <tr>
                                                    <td>{index + 1}</td>
                                                    <td style={{ position: 'relative' }}>
                                                        <input className="form-check-input" checked={x.selected} type="checkbox" onChange={(e) => updateGrid(index, 'selected', e.target.checked)} />
                                                    </td>
                                                    <td style={{ minWidth: 175 }}>
                                                        <button type="button" className="btn btn-sm btn-primary" onClick={async () => {
                                                            if (window.confirm('Are you sure?')) {
                                                                // if (data.weightRequired) {
                                                                //     if (!x.cnWeight || x.cnWeight <= 0 || x.cnWeight > 99) {
                                                                //         alert("Invalid Weight found in Grid");
                                                                //         return;
                                                                //     }
                                                                // }
                                                                await onGenerateLoadsheet([{ ...x }]);
                                                            }
                                                        }}>Generate Loadsheet</button>
                                                    </td>
                                                    <td>
                                                        {
                                                            (!x.editMode && !x.edited && !x.extra) && <button type="button" className="btn btn-sm btn-primary" onClick={e => {
                                                                updateGrid(index, 'editMode', true)
                                                            }}>Edit</button>
                                                        }
                                                    </td>
                                                    <td>{x.cn}</td>
                                                    <td>
                                                        {x.consignee}
                                                    </td>
                                                    <td>{x.pcs}</td>
                                                    <td>{x.weight}</td>
                                                    <td>{x.codAmount}</td>
                                                    <td>
                                                        {x.refNo}
                                                    </td>
                                                    <td>{x.bookingDate}</td>
                                                    <td>
                                                        {x.serviceType}
                                                    </td>
                                                    <td>
                                                        {x.productDetails}
                                                    </td>
                                                    <td>
                                                        {x.remarks}
                                                    </td>
                                                </tr>
                                                {
                                                    x.editMode &&
                                                    <tr>
                                                        <td colSpan={14}>
                                                            <div className="row mt-3 mb-3">
                                                                <div className="col-2">
                                                                    <label>Pieces</label>
                                                                    <input type="text" className="form-control" defaultValue={x.pcs} maxLength={2} onInput={processInt} onBlur={(e) => updateGrid(index, 'pcs', e.target.value)} />
                                                                </div>
                                                                <div className="col-2">
                                                                    <label>Weight</label>
                                                                    <input type="text" className="form-control" defaultValue={x.weight} maxLength={4} onInput={processNum} onBlur={(e) => updateGrid(index, 'weight', e.target.value)} />
                                                                </div>
                                                                {/* <div className="col-2">
                                                                    <label>Consignee</label>
                                                                    <input type="text" className="form-control" defaultValue={x.consignee} maxLength={50} onInput={processStrWithSpace} onBlur={(e) => updateGrid(index, 'consignee', e.target.value)} />
                                                                </div>
                                                                <div className="col-2">
                                                                    <label>Ref No</label>
                                                                    <input type="text" className="form-control" defaultValue={x.refNo} maxLength={20} onInput={processStr} onBlur={(e) => updateGrid(index, 'refNo', e.target.value)} />
                                                                </div>
                                                                <div className="col-2">
                                                                    <label>Service Type</label>
                                                                    <select className="form-select" defaultValue={x.serviceType} style={{ height: 40 }} onChange={(e) => updateGrid(index, 'serviceType', e.target.value)}>
                                                                        {services.map((x, index) => <option key={index} value={x}>{x}</option>)}
                                                                    </select>
                                                                </div>
                                                                <div className="col-2">
                                                                    <label>Product Details</label>
                                                                    <textarea className="form-control" defaultValue={x.productDetails} maxLength={600} onInput={processStrWithSpace} onBlur={(e) => updateGrid(index, 'productDetails', e.target.value)} ></textarea>
                                                                </div>
                                                                <div className="col-2">
                                                                    <label>Remarks</label>
                                                                    <textarea className="form-control" defaultValue={x.remarks} maxLength={600} onInput={processStrWithSpace} onBlur={(e) => updateGrid(index, 'remarks', e.target.value)} ></textarea>
                                                                </div> */}
                                                            </div>
                                                        </td>
                                                    </tr>
                                                }
                                            </Fragment>)
                                    }
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            }
        </div>
    </section>
}

export default DarazLoadsheet;